import { ErrorHandler, inject, Injectable } from '@angular/core';
import {
  isDeferLoadingFailedError,
  isMissingChunkError,
} from './missing-chunk-errors';
import { MissingChunkReloadService } from './missing-chunk-reload.service';

/**
 * Angular's default error handling, plus a fresh page load when a `@defer`
 * block or another dynamic import fails. Angular never retries a failed
 * `@defer` block, so without a reload it stays empty for the life of the tab.
 */
@Injectable()
export class MissingChunkErrorHandler extends ErrorHandler {
  private readonly missingChunkReload = inject(MissingChunkReloadService);

  override handleError(error: unknown): void {
    super.handleError(error);
    if (isDeferLoadingFailedError(error) || isMissingChunkError(error)) {
      this.missingChunkReload.loadFreshPage(error);
    }
  }
}
